// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.company.RentalManagerUserManagementCompanyWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission,
  RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_Path,
  RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation,
  RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_Path,
  RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation,
  RentalManagerUserManagementCompanyWebApiHandler_deactivateUser,
  RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_Path,
  RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation,
  RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_Path,
  RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission,
  RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory,
  RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser,
  RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail,
  RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers,
  RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles,
  RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles,
  RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path,
  RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail,
  RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_Path,
  RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName,
  RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_Path,
  RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings,
  RentalManagerUserManagementCompanyWebApiHandler_verifyEmail,
  RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ActivePropertyCountDto,
  ListingAlias,
  RentalManagerUserCompanyStatsDto,
  RentalManagerUserManagementInviteUserRequestDto,
  RentalManagerUserProfilesDto,
  RentalManagerUserProfileUpdateRequestDto,
  RentalManagerUserPropertyDetailsListDto,
  UserManagementActivityListDto,
  UserManagementCompanyDetailsDto,
  UserManagementCompanyPropertyDetailsListDto,
  UserManagementListingPermissionDetailsDto,
  UserManagementUnrecognizedUsersDto,
  Zuid,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface AddSingleUmcListingPermissionParams {
  email: string;
  listingAlias: ListingAlias;
}
interface CancelUserInvitationParams {
  email: string;
}
interface DeactivateUserParams {
  /**
   * @deprecated
   */
  userBrand: string;
  userToken: string;
}
interface DisableUmcListingPermissionParams {
  listingAlias: ListingAlias;
  userToken: string;
}
interface GetActivityHistoryParams {
  startTimestamp?: string;
}
interface GetCompanyListingsForUserParams {
  zuid: Zuid;
}
interface GetPendingProfileParams {
  email: string;
}
interface GetPendingUserPropertiesParams {
  email: string;
}
interface GetUmcListingPermissionDetailParams {
  listingAlias: ListingAlias;
}
interface GetUserCompanyActivePropertyCountV2Params {
  userBrand: string;
  userToken: string;
}
interface GetUserCompanyPropertiesParams {
  userBrand: string;
  userToken: string;
}
interface GetUserProfilesParams {
  /**
   * @deprecated
   */
  userBrand?: string;
  userToken?: string;
}
interface ResendInviteEmailParams {
  email: string;
}
interface UpdateCompanyNameParams {
  companyName: string;
}
interface VerifyEmailParams {
  email: string;
}

export type RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_Options = UseQueryOptions<
  UserManagementListingPermissionDetailsDto,
  unknown,
  UserManagementListingPermissionDetailsDto,
  readonly [string, AddSingleUmcListingPermissionParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_GetKey = (
  getParams: AddSingleUmcListingPermissionParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_queryOptions = (
  getParams: AddSingleUmcListingPermissionParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission = (
  getParams: AddSingleUmcListingPermissionParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_Options = UseQueryOptions<
  void,
  unknown,
  void,
  readonly [string, CancelUserInvitationParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_GetKey = (
  getParams: CancelUserInvitationParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_queryOptions = (
  getParams: CancelUserInvitationParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Cancel a pending invitation
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation = (
  getParams: CancelUserInvitationParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_GetKey;

export interface RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Args {
  postData: RentalManagerUserManagementInviteUserRequestDto;
}

export type RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Args
>;

/**
 * Create a new pending user and send invitation
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_createUserInvitation = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Args) =>
      RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation(args.postData, httpClient),
  });
};

export type RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_Options = UseQueryOptions<
  void,
  unknown,
  void,
  readonly [string, DeactivateUserParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_GetKey = (getParams: DeactivateUserParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_queryOptions = (
  getParams: DeactivateUserParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_deactivateUser(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Deactivate a user by removing permissions of features and properties
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_deactivateUser = (
  getParams: DeactivateUserParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_deactivateUser.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_Options = UseQueryOptions<
  void,
  unknown,
  void,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Decline invitation to user management
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_Options,
  'queryFn' | 'queryKey'
> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_Options = UseQueryOptions<
  UserManagementListingPermissionDetailsDto,
  unknown,
  UserManagementListingPermissionDetailsDto,
  readonly [string, DisableUmcListingPermissionParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_GetKey = (
  getParams: DisableUmcListingPermissionParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_queryOptions = (
  getParams: DisableUmcListingPermissionParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Disable UMC Listing Permission
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission = (
  getParams: DisableUmcListingPermissionParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_Options = UseQueryOptions<
  UserManagementActivityListDto,
  unknown,
  UserManagementActivityListDto,
  readonly [string, GetActivityHistoryParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_GetKey = (
  getParams: GetActivityHistoryParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_queryOptions = (
  getParams: GetActivityHistoryParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getActivityHistory = (
  getParams: GetActivityHistoryParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getActivityHistory.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Options = UseQueryOptions<
  UserManagementCompanyPropertyDetailsListDto,
  unknown,
  UserManagementCompanyPropertyDetailsListDto,
  readonly [string, GetCompanyListingsForUserParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_GetKey = (
  getParams: GetCompanyListingsForUserParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_queryOptions = (
  getParams: GetCompanyListingsForUserParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser = (
  getParams: GetCompanyListingsForUserParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Options = UseQueryOptions<
  RentalManagerUserProfilesDto,
  unknown,
  RentalManagerUserProfilesDto,
  readonly [string, GetPendingProfileParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_GetKey = (getParams: GetPendingProfileParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_queryOptions = (
  getParams: GetPendingProfileParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get an invited user's pending profile
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getPendingProfile = (
  getParams: GetPendingProfileParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getPendingProfile.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Options = UseQueryOptions<
  RentalManagerUserPropertyDetailsListDto,
  unknown,
  RentalManagerUserPropertyDetailsListDto,
  readonly [string, GetPendingUserPropertiesParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_GetKey = (
  getParams: GetPendingUserPropertiesParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_queryOptions = (
  getParams: GetPendingUserPropertiesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a pending user's properties
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties = (
  getParams: GetPendingUserPropertiesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_Options = UseQueryOptions<
  UserManagementListingPermissionDetailsDto,
  unknown,
  UserManagementListingPermissionDetailsDto,
  readonly [string, GetUmcListingPermissionDetailParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_GetKey = (
  getParams: GetUmcListingPermissionDetailParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_queryOptions = (
  getParams: GetUmcListingPermissionDetailParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail = (
  getParams: GetUmcListingPermissionDetailParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_Options = UseQueryOptions<
  UserManagementUnrecognizedUsersDto,
  unknown,
  UserManagementUnrecognizedUsersDto,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers(httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_Options =
  UseQueryOptions<
    ActivePropertyCountDto,
    unknown,
    ActivePropertyCountDto,
    readonly [string, GetUserCompanyActivePropertyCountV2Params]
  >;

const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_GetKey = (
  getParams: GetUserCompanyActivePropertyCountV2Params,
) => [RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_queryOptions = (
  getParams: GetUserCompanyActivePropertyCountV2Params,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a user's active property count
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2 = (
  getParams: GetUserCompanyActivePropertyCountV2Params,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyActivePropertyCountV2_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_Options = UseQueryOptions<
  UserManagementCompanyDetailsDto,
  unknown,
  UserManagementCompanyDetailsDto,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails(httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_Options = UseQueryOptions<
  RentalManagerUserPropertyDetailsListDto,
  unknown,
  RentalManagerUserPropertyDetailsListDto,
  readonly [string, GetUserCompanyPropertiesParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_GetKey = (
  getParams: GetUserCompanyPropertiesParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_queryOptions = (
  getParams: GetUserCompanyPropertiesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a user's company properties
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties = (
  getParams: GetUserCompanyPropertiesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Options = UseQueryOptions<
  RentalManagerUserCompanyStatsDto,
  unknown,
  RentalManagerUserCompanyStatsDto,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats(httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Options = UseQueryOptions<
  RentalManagerUserProfilesDto,
  unknown,
  RentalManagerUserProfilesDto,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the current user's company users
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Options = UseQueryOptions<
  RentalManagerUserProfilesDto,
  unknown,
  RentalManagerUserProfilesDto,
  readonly [string, GetUserProfilesParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_GetKey = (getParams: GetUserProfilesParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_queryOptions = (
  getParams: GetUserProfilesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user profiles including feature access and properties permissions
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getUserProfiles = (
  getParams: GetUserProfilesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserProfiles.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_Options = UseQueryOptions<
  void,
  unknown,
  void,
  readonly [string, ResendInviteEmailParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_GetKey = (getParams: ResendInviteEmailParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_queryOptions = (
  getParams: ResendInviteEmailParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail = (
  getParams: ResendInviteEmailParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_Options = UseQueryOptions<
  string,
  unknown,
  string,
  readonly [string, UpdateCompanyNameParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_GetKey = (getParams: UpdateCompanyNameParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_queryOptions = (
  getParams: UpdateCompanyNameParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_updateCompanyName = (
  getParams: UpdateCompanyNameParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_updateCompanyName.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_GetKey;

export interface RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Args {
  postData: RentalManagerUserProfileUpdateRequestDto;
}

export type RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Args
>;

/**
 * Update existing user settings
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_updateUserSettings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Args) =>
      RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings(args.postData, httpClient),
  });
};

export type RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_Options = UseQueryOptions<
  void,
  unknown,
  void,
  readonly [string, VerifyEmailParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_GetKey = (getParams: VerifyEmailParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_queryOptions = (
  getParams: VerifyEmailParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_verifyEmail(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Verify if an email can be added to a company
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_verifyEmail = (
  getParams: VerifyEmailParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_verifyEmail.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_GetKey;
